import { AxiomReportType, AxiomReportTypeFullNames } from '@/enums/axiom-report.enum'
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material'
import React, { useState } from 'react'

interface ReportTypeDropdownProps {
  value?: AxiomReportType
  onChange?: (value: AxiomReportType) => void
}

const ReportTypeDropdown: React.FC<ReportTypeDropdownProps> = ({ 
  value: externalValue, 
  onChange: externalOnChange 
}) => {
  // Filter to show only SCEN, GFPA, GFPAH, GFR, MENU and RV
  const allowedReportTypes = [
    AxiomReportType.SCEN,
    AxiomReportType.GFPA,
    AxiomReportType.GFPAH,
    AxiomReportType.GFR,
    AxiomReportType.MENU,
    AxiomReportType.RV,
  ]
  const [internalValue, setInternalValue] = useState<AxiomReportType>(AxiomReportType.SCEN)

  // Use external value if provided, otherwise use internal state
  const selectedReportType = externalValue !== undefined ? externalValue : internalValue

  const handleChange = (event: SelectChangeEvent<AxiomReportType>) => {
    const newValue = event.target.value as AxiomReportType
    
    if (externalOnChange) {
      externalOnChange(newValue)
    } else {
      setInternalValue(newValue)
    }
  }

  return (
    <FormControl variant='outlined'>
      <InputLabel id='report-type'>Report Type</InputLabel>
      <Select
        size='small'
        id='report-type'
        label='Report Type'
        value={selectedReportType}
        onChange={handleChange}
      >
        {allowedReportTypes.map((method) => (
          <MenuItem key={method} value={method}>
            {AxiomReportTypeFullNames[method]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default ReportTypeDropdown
